module.exports = __webpack_public_path__ + "static/design_process-9f8190255c8e675021f495c80ecba951.png";